<template>
  <v-row
    :class="
      'search-form fixed ' +
      width_class +
      ' top-' +
      (has_nav_bar ? 'with-nav-bar' : 'no-nav-bar')
    "
    no-gutters
  >
    <v-col no-gutters>
      <v-row no-gutters>
        <v-col cols="12 pt-4" no-gutters>
          <v-row no-gutters>
            <v-col class="ma-0 pl-6 pr-0 pb-0">
              <v-autocomplete
                prepend-inner-icon="mdi-city"
                dense
                filled
                outlined
                clearable
                label="Search for a business ..."
                class="flex-md-grow-1 round-right-0"
                no-filter
                return-object
                v-model="value"
                :disabled="is_loading_auto_complete_items || disabled"
                :items="business_names"
                :search-input.sync="business_name_searching_val"
                :no-data-text="'Enter business name ...'"
                :error-messages="errors"
              ></v-autocomplete>
            </v-col>
            <v-col class="ma-0 pl-0 pr-0 pb-0">
              <v-autocomplete
                prepend-inner-icon="mdi-map-marker"
                dense
                filled
                outlined
                clearable
                label="Location"
                class="flex-md-grow-1 round-right-0 round-left-0"
                no-filter
                return-object
                v-model="location_value"
                :disabled="is_loading_auto_complete_items || disabled"
                :items="location_names"
                :search-input.sync="location_name_searching_val"
                :no-data-text="'Enter a name of a location ...'"
              ></v-autocomplete>
            </v-col>
            <v-col class="ma-0 pl-0 pr-6 pb-0" md="auto">
              <v-btn
                @click="on_search"
                class="ma-0 round-right-4 hgt-40"
                tile
                filled
                ripple
                xoutlined
                color="primary"
              >
                Search
                <v-icon right>mdi-home-search-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="show_pagination">
        <v-col cols="12" no-gutters>
          <v-row no-gutters align="center" class="pb-2">
            <v-col no-gutters class="d-flex justify-start pl-6">
              <div v-show="!has_no_query">Found {{comma(search_results_count)}} Results</div>
              <div v-show="has_no_query">search page ...</div>
            </v-col>
            <v-col no-gutters class="d-flex justify-end pr-3">
              <v-pagination
                v-model="search_page"
                :length="(search_results_count <= 0)?1:(Math.ceil(search_results_count/search_page_size))"
                :total-visible="5"
                :disabled="disabled || has_no_query"
                @input="page_changed"
              ></v-pagination>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-col>
    
  </v-row>
</template>

<script>
import Server from "./../lib/ServerClient";
import ServerClient from "./../lib/ServerClient";
import page_info from "../lib/page_info";
import Utils from "../lib/Utils";
export default {
  name: "CenterSearchForm",
  props: {
    has_nav_bar: {
      type: Boolean,
      default: true,
    },
    width_class: {
      type: String,
      default: "wdth-50p",
    },
    show_pagination: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    is_on_search_page: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      business_name_searching_val: null,
      location_name_searching_val: null,
      value: "",
      location_value: "",
      business_names: [],
      location_names: [],
      is_loading_auto_complete_items: false,
      errors: [],
      bid: 0,
      bq: "",
      lid: 0,
      lk: "",
      lq: "",
      search_results_count: 0,
      search_results: [],
      search_page: 0,
      search_page_size: page_info.search_results_page_size,
      has_no_query: true
    };
  },
  watch: {
    business_name_searching_val: function (val) {
      if (!val) {
        this.value = "";
        return true;
      }
      var value_text = val.trim().toLowerCase();
      var insert_prefix = ""; //"search for: ";
      var text_exists = false;
      for (let index = 0; index < this.business_names.length; index++) {
        var business = this.business_names[index];
        var item_text = business.text.trim().toLowerCase() + insert_prefix;
        if (item_text == value_text) {
          //this text is already with us
          text_exists = true;
          break;
        }
      }
      if (text_exists) {
        return true;
      }

      Server.Search.auto_complete_search_businesses(
        {
          search_term: value_text,
        },
        (res) => {
          //console.log("ser", res);
          var text_totaly_exists = false;
          var new_items = [];
          var server_items = res;
          for (let index = 0; index < server_items.length; index++) {
            var item = server_items[index];
            var item_text = item.text.trim().toLowerCase();
            if (item_text.indexOf(value_text) >= 0) {
              //server result contains this item
              text_totaly_exists = true;
            }
            item.kind = "business";
            new_items.push({
              text: item_text,
              value: item,
            });
          }
          if (text_totaly_exists == false) {
            //push this item as the first item
            new_items.unshift({
              text: value_text + insert_prefix,
              value: {
                id: 0,
                name: value_text,
                kind: "business",
                value: {
                  id: 0,
                  name: value_text,
                  kind: "business",
                },
              },
            });
          }
          this.business_names = new_items;
          //console.log("businesses names: ", this.business_names);
        },
        (errs) => {
          console.log("auto complete searching_val errors value: ", errs);
        }
      );
    },
    location_name_searching_val: function (val) {
      if (!val) {
        this.location_value = "";
        return true;
      }
      var value_text = val.trim().toLowerCase();
      var insert_prefix = ""; //"search for: ";
      var text_exists = false;
      for (let index = 0; index < this.location_names.length; index++) {
        var location = this.location_names[index];
        var item_text = location.text.trim().toLowerCase() + insert_prefix;
        if (item_text == value_text) {
          //this text is already with us
          text_exists = true;
          break;
        }
      }
      if (text_exists) {
        return true;
      }

      Server.Search.auto_complete_search_locations(
        {
          search_term: value_text,
        },
        (res) => {
          //console.log("ser", res);
          var text_totaly_exists = false;
          var new_items = [];
          var server_items = res;
          for (let index = 0; index < server_items.length; index++) {
            var item = server_items[index];
            var item_text = item.text.trim().toLowerCase();
            if (item_text.indexOf(value_text) >= 0) {
              //server result contains this item
              text_totaly_exists = true;
            }
            item.kind = "business";
            new_items.push({
              text: item_text,
              value: item.value,
            });
          }
          if (text_totaly_exists == false) {
            //push this item as the first item
            new_items.unshift({
              text: value_text + insert_prefix,
              value: {
                id: 0,
                name: value_text,
                kind: "any",
              },
            });
          }
          this.location_names = new_items;
          //console.log("businesses names: ", this.business_names);
        },
        (errs) => {
          console.log(
            "auto complete location searching_val errors value: ",
            errs
          );
        }
      );
    },
  },
  methods: {
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      var temp = Utils.add_commas(v);
      if(temp == "00"){
        temp = "NO";
      }
      return temp;
    },
    auto_search_businesses(val) {
      console.log("The value is ", val);
    },
    is_search_valid(){
      var is_valid = true;
      if(this.value == null || this.value == ""){
        is_valid = false;
      }
      return is_valid;
    },
    on_search() {
      //if component is on search page
      if (this.is_on_search_page == true) {
        var valid = this.is_search_valid();
        if(valid == false){
          this.errors = ["Please enter and select a business search term"];
          return false;
        }
        this.has_no_query = false;
        this.search_page = 1;
        this.errors = [];
        this.search_for_businesses();
      } else {
        //console.log("Business value ", this.value);
        //console.log("Location value ", this.location_value);
        this.errors = [];
        if (this.value == null || this.value == "") {
          this.errors = ["Please provide a search term for the business"];
          return false;
        }
        var q = "";
        q = q + "bid=" + this.value.value.value.id;
        q = q + "&bq=" + this.value.text.trim().substring(0, 51);
        if (this.location_value != null && this.location_value != "") {
          q = q + "&lid=" + this.location_value.value.id;
          q = q + "&lk=" + this.location_value.value.kind;
          q = q + "&lq=" + this.location_value.text.trim().substring(0, 51);
        }
        this.$router.push("/search?" + q);
      }
    },
    search_for_businesses() {
      //for knowing who searhed
      var user_id = 0;
      var temp_user = ServerClient.Login.get_logged_in_user();
      if(temp_user && temp_user != null ){
        user_id = parseInt(temp_user.id);
      }

      this.$emit("on-show-loader");
      ServerClient.Search.find_businesses(
        {
          is_auto_complete: false,
          location_filter: this.location_value,
          business_filter: this.value,
          page: this.search_page,
          page_size: this.search_page_size,
          user_id: user_id
        },
        (res) => {
          this.$emit("on-hide-loader");
          // console.log("Hello from here: ", res);
          this.search_results_count = parseInt(res.results_found);
          this.$emit("on-render-results", res);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors finding business on  search page: ", errors);
        }
      );
    },
    page_changed(pg){
      //console.log("Page has changed ", this.search_page, pg);
      this.search_for_businesses();
    }
  },
  mounted() {
    this.search_results_count = 0;
    this.search_results = [];
    this.search_page = 0;
    //load the business names for auto complete purposes
    this.is_loading_auto_complete_items = true;
    //This has been disabled for performance reasons
    // Server.Search.get_home_search_autocomplete_items({},(res)=>{
    //   /*
    //     {
    //       business_names,
    //       locations_names
    //     }
    //   */
    //   this.business_names = res.business_names;
    //   this.location_names = res.locations_names;
    //   this.is_loading_auto_complete_items = false;
    // },(errors) => {
    //   this.is_loading_auto_complete_items = false;
    //   console.log("Errors while loading auto completing items: ", errors);
    // });
    this.is_loading_auto_complete_items = false;
    this.business_names = [];
    this.location_names = [];

    //if component is on search page
    if (this.is_on_search_page) {
      var has_query =  false;
      var path_query = this.$route.query;
      //console.log("Routes are here: ", path_query);
      if (path_query.bid) {
        this.bid = parseInt(path_query.bid);
        has_query = true;
      }
      if (path_query.bq) {
        this.bq = path_query.bq.trim();
        has_query = true;
      }
      if (path_query.lid) {
        this.lid = parseInt(path_query.lid);
        has_query = true;
      }
      if (path_query.lk) {
        this.lk = path_query.lk.trim();
        has_query = true;
      }
      if (path_query.lq) {
        this.lq = path_query.lq.trim();
        has_query = true;
      }

      //formulate search sources
      var insert_prefix = "";
      if (this.bq.length > 0) {
        this.business_names = [
          {
            text: this.bq,
            value: {
              id: this.bid,
              name: this.bq,
              kind: "business",
              value: {
                id: this.bid,
                name: this.bq,
                kind: "business",
              },
            },
          },
        ];
        this.value = this.business_names[0];
      }
      if (this.lq.length > 0) {
        this.location_names = [
          {
            text: this.lq,
            value: {
              id: this.lid,
              name: this.lq,
              kind: this.lk,
            },
          },
        ];
        this.location_value = this.location_names[0];
      }

      this.has_no_query = !has_query;

      //do the search if query is fine
      if (this.bq.length > 0) {
        this.on_search();
      }else if(has_query == false){
        this.$emit("on-has-no-search-query");
      }
    }
  },
};
</script>

<style scoped>
.search-form {
  /*  #a9a9a905; */
  background-color: white;
  padding-top: 4px;
  z-index: 99;
}
</style>